<template>
  <div
    class="content"
    style="padding: 2rem;"    
  >
    <h1>You are getting redirected to the authentication provider...</h1>
  </div>
</template>

<script>
import um from '@/common/oidc'

export default {
  mounted() {
    um.signinPopupCallback((new URLSearchParams(location.search)).toString())
      .catch((err) => {
        /* TODO Handle this error correctly */
        alert('Auth error: Please check your browser logs.')
      })
  }
}
</script>